import React, { useEffect, useState, useCallback } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import {
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
} from '@material-ui/core';

import { useStyles, Form } from './styles';
import { useAuth } from '../../../../hooks/auth';
import { IGeoapify, useGeoapify } from '../../hooks/geoapify';

import { Button } from '../../../../components/Button';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const Geoapify: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const {
    data: { user },
  } = useAuth();
  const { loadGeoapify, saveGeoapify } = useGeoapify();
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingGeoapify, setLoadingGeoapify] = useState(true);
  const [data, setData] = useState<IGeoapify>({
    apiKey: '',
  });

  useEffect(() => {
    async function loadIntegration(): Promise<void> {
      try {
        const response = await loadGeoapify(user.companyDocument);

        if (!response) return;

        setData({
          ...response,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingGeoapify(false);
      }
    }
    if (props.open) loadIntegration();
  }, [loadGeoapify, props.open, user.companyDocument]);

  const validationSchema = yup.object().shape({
    apiKey: yup.string(),
    days: yup.number(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...data,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoadingButton(true);

      try {
        await saveGeoapify(values);
        props.onClose();
      } catch (error) {
        console.log(error);
      }

      setLoadingButton(false);
    },
  });

  const handleClose = useCallback(() => {
    props.onClose();
    formik.resetForm();
    setLoadingGeoapify(true);
  }, [props, formik]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">GEOAPIFY</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={formik.handleSubmit}
          noValidate
          className={classes.form}
        >
          <Grid container spacing={3}>
            {loadingGeoapify ? (
              <Grid item xs={12}>
                <Typography component="div" align="center">
                  <CircularProgress />
                </Typography>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={12}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="ApiKey"
                    id="apiKey"
                    name="apiKey"
                    value={formik.values.apiKey}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.apiKey && Boolean(formik.errors.apiKey)
                    }
                    helperText={formik.touched.apiKey && formik.errors.apiKey}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Fechar
        </Button>

        <Button
          onClick={() => formik.handleSubmit()}
          color="secondary"
          variant="contained"
          loading={loadingButton}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
